import { applyUsableFilters, convertStringToArray, generateErrors, applyTransportPlanLegVoyages } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { IStore } from 'reducers/index';
import { Action } from 'redux';
import { TYPES as FILTER_TYPES } from 'action-types/filters';
import { TYPES } from 'action-types/fcr';
import { displayFilters } from 'actions/filters';
import { callApiV2Get, callApiV2Post } from 'utilities/apiCaller';
import API from 'constants/api';

export const fetchDocuments = (pageNumber?: number, pageSize?: number, genericFilter?: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.FETCH_FCR.PENDING });
        displayFilters(false, 'jobCostingFiltersDocument')
        try {
            const res = await callApiV2Post(API.FCR.FcrSearch,
                applyUsableFilters(convertStringToArray(getState, 'ReferenceNumbers'), {
                    Page: pageNumber,
                    PageSize: pageSize
                }), {});
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: TYPES.FETCH_FCR.FULFILLED, documents: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_FCR.REJECTED, errors });
        }
    }
};

export const resetDocuments = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.RESET_FCR.PENDING });
        dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: 0 });
        dispatch({ type: TYPES.RESET_FCR.FULFILLED, documents: [] });

    }
};
export const fetchFCRDetails = (documentId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_FCR_DETAILS.PENDING });
        try {
            const res = await callApiV2Get(`${API.FCR.FcrDetails}/${documentId}`, {}, {});
            dispatch({ type: TYPES.FETCH_FCR_DETAILS.FULFILLED, documentDetails: applyTransportPlanLegVoyages(res.data) });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.FETCH_FCR_DETAILS.REJECTED, errors });
        }
    }
};